import React, { useEffect, useState } from "react";
import {
  SimpleForm,
  useRedirect,
  ReferenceInput,
  SelectInput,
  CreateProps,
  Toolbar,
  Button,
  useMutation,
  useNotify,
  AutocompleteInput,
} from "react-admin";
import { GetParam, StudentResources } from "utils/tools";
import { CircularProgress, Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import SaveIcon from "@material-ui/icons/Save";
import { useFormState } from "react-final-form";
import { find } from "lodash";
import CreateWrapper from "../../components/CreateWrapper";

const CustomCreateToolbar = (props: any) => {
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const { values } = useFormState();

  const redirect = useRedirect();
  const notify = useNotify();

  useEffect(() => {
    if (values.studentId && values.parentId) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [values]);

  const [handleSavePermission, { loading }] = useMutation(
    {
      type: "customCreate",
      resource: `students/${values.studentId}/permissions`,
      payload: {
        data: {
          studentId: values.studentId,
          parentId: values.parentId,
        },
      },
    },
    {
      onSuccess: ({ data }) => {
        notify(`Successfully save.`, "info");
        redirect(props.redirectLink);
      },
      onFailure: (error) =>
        notify(`Failed save, error: ${error.message}`, "warning"),
    }
  );

  return (
    <Toolbar {...props}>
      <Button
        onClick={handleSavePermission}
        disabled={isDisabled || props.invalid}
        label={loading ? "SAVING..." : "SAVE"}
      >
        {loading ? <CircularProgress size={18} thickness={2} /> : <SaveIcon />}
      </Button>
    </Toolbar>
  );
};

const PermissionCreate = (props: CreateProps) => {
  const param = GetParam();

  const StudentResource = StudentResources(Number(param.get("studentId")));

  let breadcrumbValue = [{ link: "", title: "", params: "" }];

  if (param.get("parentId")) {
    breadcrumbValue = [
      {
        title: "Parents",
        link: `/parents/${param.get("parentId")}/show`,
        params: "",
      },
      {
        title: "Students",
        link: `/students/${param.get("studentId")}/show`,
        params: `?parentId=${param.get("parentId")}`,
      },
      {
        title: "Permissions",
        link: `/students/${param.get("studentId")}/show/5`,
        params: `?parentId=${param.get("parentId")}`,
      },
      {
        title: "Create",
        link: "",
        params: "",
      },
    ];
  } else {
    breadcrumbValue = [
      {
        title: "Students",
        link: `/students/${param.get("studentId")}/show`,
        params: "",
      },
      {
        title: "Permissions",
        link: `/students/${param.get("studentId")}/show/5`,
        params: "",
      },
      {
        title: "Create",
        link: "",
        params: "",
      },
    ];
  }

  const breadcrumb = breadcrumbValue;
  const redirectLink = find(breadcrumbValue, { title: "Permissions" });

  return (
    <>
      <CreateWrapper
        breadcrumb={breadcrumb}
        headerTitle="New Permission"
        {...props}
      >
        <SimpleForm
          toolbar={<CustomCreateToolbar redirectLink={redirectLink.link} />}
        >
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Student</Typography>
            </Grid>
            <Grid item xs={3}>
              <ReferenceInput
                label="Select Student"
                source="studentId"
                reference="students"
                disabled
              >
                <SelectInput
                  optionText={(choice: any) =>
                    `${choice.firstName} ${choice.lastName}`
                  }
                />
              </ReferenceInput>
            </Grid>
            <Grid item xs={9}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Parent</Typography>
            </Grid>
            <Grid item xs={3}>
              <ReferenceInput
                label="Select Parent"
                source="parentId"
                filter={{
                  ExcludeParentId: StudentResource?.parent?.id,
                }}
                filterToQuery={(searchText: any) => {
                  if (searchText !== "") return { search: searchText };
                }}
                reference="parents"
              >
                <AutocompleteInput
                  optionText={(choice: any) =>
                    `${choice.firstName} ${choice.lastName} - ${choice.user.email} - ${choice.mobile}`
                  }
                />
              </ReferenceInput>
            </Grid>
            <Grid item xs={9}></Grid>
          </SanitizedGrid>
        </SimpleForm>
      </CreateWrapper>
    </>
  );
};

export default PermissionCreate;
